import { AppNameComponent } from './data-widgets/app-name.component';
import { CoppaAudienceComponent } from './data-widgets/coppa-audience.component';
import { DomainNameComponent } from './data-widgets/domain-name.component';
import { GridHeaderWithPopoverComponent } from './data-widgets/grid-header-with-popover.component';
import { GridHeaderWithTooltipComponent } from './data-widgets/grid-header-with-tooltip.component';
import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { RankDataComponent } from './data-widgets/rank-data.component';
import { RankGradeComponent } from './data-widgets/rank-grade.component';
import { ReportConfig } from './REPORT_CONFIG';
import { CTV_OPTIONS } from './REPORT_CONFIG_CONST';

export const REPORT_CONFIG_PUBLISHER_TRUST_INDEX: ReportConfig = {
  key: 'publisher-trust-index',
  heading: 'Publisher Trust Index',
  title: 'Publisher Trust Index',
  formTitle: 'Publisher Trust Index',
  pageTitle:
    'Publisher Trust Index - Quality Publisher Rankings for the Programmatic Supply Chain',
  pageMeta:
    'Publisher Trust Index, a Pixalate Rankings index, introduces a new rating standard for measuring publisher quality across {type} in the {platformName}.',
  reportId: 'publisherTrustIndex',
  permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
  cta: {
    anonHeading: 'Unlock More Rankings & Scores:'
  },
  rowLimit: 10,
  fadeStart: 5,
  sortable: true,
  mainFilterItems: [
    {
      key: 'platformName',
      label: 'OS',
      selected: {
        label:
          '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Android',
        value: 'android'
      },
      groups: ['app'],
      hidden: false,
      type: 'toggle-filter',
      options: [
        {
          label:
            '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
          value: 'android'
        },
        {
          label:
            '<img class="mr-2" src="/assets/images/apple.svg" alt="App Store Icon"/> App Store',
          value: 'ios'
        }
      ]
    },
    {
      key: 'platformName',
      label: 'OS',
      selected: CTV_OPTIONS[0],
      groups: ['ctv'],
      hidden: false,
      type: 'toggle-filter',
      options: [...CTV_OPTIONS]
    },
    {
      key: 'category',
      label: 'Category',
      selected: { label: 'All Categories', value: 'GLOBAL' },
      hidden: false,
      dependencies: [
        {
          label: 'Region'
        },
        {
          key: 'date'
        },
        {
          key: 'platformName'
        }
      ],
      options: [{ label: 'All Categories', value: 'GLOBAL' }],
      default: { label: 'All Categories', value: 'GLOBAL' }
    },
    {
      key: 'countryCode',
      label: 'Region',
      selected: { label: 'North America', value: 'NA' },
      hidden: false,
      dependencies: [
        {
          key: 'platformName'
        },
        {
          key: 'date'
        }
      ],
      options: [{ label: 'North America', value: 'NA' }],
      default: { label: 'North America', value: 'NA' }
    },
    {
      key: 'countryCode',
      label: 'Country',
      selected: { label: 'All Countries', value: 'GLOBAL' },
      hidden: false,
      dependencies: [
        {
          key: 'platformName'
        },
        {
          key: 'date'
        },
        {
          label: 'Region'
        }
      ],
      options: [{ label: 'All Countries', value: 'GLOBAL' }],
      default: { label: 'All Countries', value: 'GLOBAL' }
    },
    {
      key: 'date',
      label: 'Month',
      selected: null,
      hidden: false,
      dependencies: [
        {
          group: 'app',
          key: 'platformName'
        }
      ],
      options: []
    }
  ],
  gridHeaders: [
    {
      label: 'Rank',
      key: 'rank',
      sort: 'sort-asc',
      sortDefault: false,
      sortColumnKey: 'rank',
      hoverKey: '',
      template: null, // <div class="rank-change" data-rank-value="${rankChange}">${rankChange} <i class="fa fa-arrow-up"></i><i class="fa fa-arrow-down"></i></div>',
      widgetComponent: RankDataComponent,
      hidden: false,
      tooltipText: {
        app: null,
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'App Name',
      key: 'appTitle',
      groups: ['app', 'ctv'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: AppNameComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Domain',
      key: 'adDomain',
      groups: ['domain'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: DomainNameComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Final<br/>Score',
      key: 'finalScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: 'finalScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: 'This score corresponds to the average of all the individual scores, excluding the COPPA Audience Assessment.',
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Popularity<br/>Score',
      key: 'popularityScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: 'popularityScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: 'Programmatic reach score is calculated in terms of reach and inventory availability to illustrate potential reach as compared to the their competitors.',
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'IVT<br/>Score',
      key: 'ivtScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: 'ivtScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: 'IVT Score corresponds to the percentage of IVT of the publisher compared to their peers in a given category & geography.',
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Brand Safety<br/>Score',
      key: 'brandSafetyScore',
      sort: '',
      groups: ['app', 'domain'],
      sortDefault: false,
      sortColumnKey: 'brandSafetyScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: 'This score captures our assessment of brand unsafe keywords identified in the app content description and or brand unsafe advisories declared by a given app in their app store page.',
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Ads.txt<br/>Score',
      key: 'adsTxtScore',
      sort: '',
      groups: ['app', 'domain'],
      sortDefault: false,
      sortColumnKey: 'adsTxtScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: 'This score corresponds to the detected presence of ads.txt for a given publisher, as well as the presence of a “balanced” mix of sellers and resellers compared to its competitors.',
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'MFA Score',
      key: 'mfaScore',
      sort: '',
      groups: ['domain'],
      sortDefault: false,
      sortColumnKey: 'mfaScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: null,
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Ad Density<br/>Score',
      key: 'adDensityScore',
      sort: '',
      groups: ['domain'],
      sortDefault: false,
      sortColumnKey: 'adDensityScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: null,
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Viewability<br/>Score',
      key: 'viewabilityScore',
      sort: '',
      groups: ['app', 'domain'],
      sortDefault: false,
      sortColumnKey: 'viewabilityScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: 'This score corresponds to the performance of the app in terms of its viewability.',
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Permission<br/>Score',
      key: 'permissionsScore',
      sort: '',
      groups: ['app'],
      sortDefault: false,
      sortColumnKey: 'permissionsScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: 'This score corresponds to the increase in the likelihood of the presence of IVT when specific permissions are requested by the app that are not common for its category.',
        ctv: null,
        domain: null
      },
      tooltipPos: 'left',
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      showIfReq: {
        isFilter: {
          platform: 'android'
        }
      }
    },
    {
      label: 'Ad Density<br/>Score',
      key: 'adDensityScore',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: 'adDensityScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: null,
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'Engagement<br/>Score',
      key: 'userEngagementScore',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: 'userEngagementScore',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      lockIfAnonymous: true,
      tooltipText: {
        app: null,
        ctv: null,
        domain: null
      },
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    {
      label: 'COPPA Audience<br/>Assessment',
      key: 'coppaAudience',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: CoppaAudienceComponent,
      hidden: false,
      lockIfAnonymous: true,
      groups: ['app', 'ctv'],
      tooltipText: {
        app: "Pixalate's assessment of the likely target audience of the app, according to Pixalate's COPPA methodology. This assessment is not factored into the Final Score.<br/><a target='_blank' href=\"https://www.pixalate.com/coppa-compliance-tools-methodology\">See methodology <i class='fa fa-external-link'></i></a>",
        ctv: "Pixalate's assessment of the likely target audience of the app, according to Pixalate's COPPA methodology. This assessment is not factored into the Final Score.<br/><a target='_blank' href=\"https://www.pixalate.com/coppa-compliance-tools-methodology\">See methodology <i class='fa fa-external-link'></i></a>",
        domain: null
      },
      headerWidgetComponent: GridHeaderWithPopoverComponent
    }
  ]
};
